export default (api) => ({
  fetch: (params) => api.$get("/users", { params }),

  fetchOne: (id) => api.$get(`/users/${id}`),

  create: (body) => api.$post("/users", body),

  patch: (id, body) => api.$patch(`/users/${id}`, body),

  remove: (id) => api.$delete(`/users/${id}`),

  fetchRoles: () => api.$get("/users/roles"),

  fetchAgencies: (instanceId) =>
    api.$get(`/instances/${instanceId}/agencies/all`, { params: { size: 10000 } }),

  preparecsv: (params) => api.$get("/users/preparecsv", { params }),
});
